<template>
  <highcharts class="chart" :options="options" ref="highchart" />
</template>

<script>
import { isNil, isEqual, isEmpty, cloneDeep, map } from 'lodash';
import moment from 'moment';
import { stackedColumnOptions } from '@/constants/chart-options';
import AmsResultAPI from '@/api/ams/result';

export default {
  name: 'WStackedColumnChart',
  props: {
    selectedResult: {
      type: Object,
      default: () => null,
    },
    dateParams: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      options: cloneDeep(stackedColumnOptions),
    };
  },
  watch: {
    dateParams(o) {
      if (isNil(o)) {
        this.options.series = [];
      } else {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      const startDatetime = moment(this.dateParams.startDatetime);
      const endDatetime = moment(this.dateParams.endDatetime);
      const diff = endDatetime.diff(startDatetime, 'hours');
      let labelFormat = '{value: %Y-%m-%d}';
      let interval = null;
      let tooltipFormat = '%Y-%m-%d';
      if (diff < 1) {
        labelFormat = '{value: %H:%M}';
        tooltipFormat += ' %H:%M';
      } else if (diff > 0 && diff <= 24) {
        labelFormat = '{value: %H시}';
        interval = 3600 * 1000;
        tooltipFormat += ' %H시';
      }
      this.options.xAxis.tickInterval = interval;
      Object.assign(this.options.xAxis.labels, { format: labelFormat });
      this.options.tooltip.xDateFormat = tooltipFormat;
      const resultStatusList = [
        {
          name: '성공',
          resultStatus: 'S',
          color: 'rgb(86, 139, 210)',
        },
        {
          name: '실패',
          resultStatus: 'F',
          color: 'rgb(253, 116, 132)',
        },
      ];
      const params = {
        startDatetime: this.dateParams.startDatetime,
        endDatetime: this.dateParams.endDatetime,
        triggerId: this.selectedResult.triggerId,
        jobId: this.selectedResult.jobId,
        nodeId: this.selectedResult.nodeId,
        resultStatusList,
      };
      AmsResultAPI.getTriggerExectionResultRawDataStackedColumnChartData(params).then((response) => {
        this.options.series = response.data.data;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/components/AnalysisStackedColumnChart.vue